import styled from "styled-components";

import { FlexContainer, FlexSection, Box } from "@/components/Atoms/Box";

import Button from "@/components/Atoms/Button";
import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const FixedSection = styled(FlexSection)`
  opacity: 0;
  visibility: hidden;
  background-color: ${theme.colorsV2.primary.shade_200};
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  transition: all 0.3s ease-in-out;
  z-index: 1000;
  box-shadow: 0px -4px 20px rgba(${theme.colors.shadows.black}, 0.02);
  @media only screen and (max-width: 1023px) {
    opacity: 1;
    visibility: visible;
  }
`;

export const WrapContainer = styled(FlexContainer)`
  justify-content: space-between;
  align-items: center;
  padding: 32px 16px;
  gap: 16px;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 32px 24px 32px 24px;
    gap: 24px;
  }
`;

export const LHSSection = styled(Box)``;

export const RHSSection = styled(Box)``;

export const StyledTitle = styled(Typography)`
  font-size: 20px;
  line-height: 40px;
  color: ${theme.colorsV2.primary.shade_900};
  @media only screen and (max-width: 600px) {
    font-size: 20px;
    line-height: 24px;
    font-family: var(--man-700);
  }
`;

export const StyledCTAButton = styled(Button)`
  p {
    font-family: var(--man-700);
    color: ${theme.colorsV2.primary.shade_800};
  }
  @media only screen and (max-width: 600px) {
    padding: 16px 40px 16px 40px;
  }
`;
